export enum UserRoleEnum {
  Administrator = 'Administrator',
  Expert = 'Expert',
  Supervisor = 'Supervisor',
  Operator = 'Operator',
  Client = 'Client'
}

export const allUserRoles = Object.keys(UserRoleEnum);
